import { useTranslation } from 'react-i18next';

// 필수 (essential) / 선택 (optional) pill shown next to a term name.
// Prototype: settings.html badge() + terms-view.html `.termsview__tag`.
export function TermBadge({ required }: { required: boolean }) {
  const { t } = useTranslation('termsPolicies');
  return (
    <span
      className={`terms-badge ${required ? 'terms-badge--required' : 'terms-badge--optional'}`}
    >
      {required ? t('badge.required') : t('badge.optional')}
    </span>
  );
}
